var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5604 0H10.1898V13.6232C10.1898 15.2464 8.89349 16.5797 7.28022 16.5797C5.66695 16.5797 4.37057 15.2464 4.37057 13.6232C4.37057 12.029 5.63814 10.7246 7.19381 10.6667V7.24639C3.7656 7.30433 1 10.1159 1 13.6232C1 17.1594 3.82321 20 7.30904 20C10.7948 20 13.618 17.1304 13.618 13.6232V6.63767C14.8856 7.56522 16.4412 8.11594 18.0833 8.14494V4.72464C15.5482 4.63768 13.5604 2.55072 13.5604 0Z",
    fill: "#9C9CAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon-tiktok.d460da188f6b1dbca5599ffc043113f4.svg";
export { ForwardRef as ReactComponent };